/**
 * Check if a string is a valid Clarity ID
 * Clarity ID format: alphanumeric random string with 10 characters
 *
 * @param str - The string to validate
 * @returns Returns true if the string is a valid Clarity ID
 */
export function isClarityId(str: string): boolean {
  if (typeof str !== "string") {
    return false;
  }

  // Clarity ID: alphanumeric (a-z, A-Z, 0-9) with exactly 10 characters
  const clarityIdRegex = /^[a-zA-Z0-9]{10}$/;
  return clarityIdRegex.test(str);
}
